.button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 4px 0;
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
  cursor: pointer;
  border-bottom: 1px solid var(--color-border-dark);

  &:hover {
    color: var(--color-text-primary);
    text-decoration: underline;
  }
}

.dropdownWrapper {
  position: relative;
  user-select: none;
}

.dropdown {
  position: absolute;
  top: 100%;
  z-index: 1;
  width: 100%;
  max-height: 14.4rem;
  overflow: scroll;
  background: var(--color-white);
  border: 1px solid var(--color-border-normal);
}

.dropdownList {
  padding: 8px;
}

.dropdownLink {
  display: flex;
  align-items: center;
  padding: 4px;
  font-size: var(--font-size-xs);
  color: var(--color-text-primary);

  &:hover {
    text-decoration: underline;
    background: #f2f2f2;
  }

  &::before {
    width: 20px;
    height: 20px;
    margin-right: 8px;
    content: '';
    background: var(--custom-bg-color);
    border-radius: 50%;
  }
}

.overlay {
  position: fixed;
  inset: 0;
}
